var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible",
        },
      ],
      staticClass: "gfu-pager gfu-flex__item",
    },
    [_c("span", [_vm._v("pager")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }